module.exports = __webpack_public_path__ + "static/media/CFC-final.b7d9b86d.jpg";